import axios, {AxiosResponse} from 'axios'
import {ModusOperandiQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/modus-operandi`

const getModusOperandi = (query: string): Promise<ModusOperandiQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<ModusOperandiQueryResponse>) => d.data)
}

export {getModusOperandi}
